import { render, staticRenderFns } from "./reviewOpinion.vue?vue&type=template&id=4417bf3d&scoped=true&"
import script from "./reviewOpinion.vue?vue&type=script&lang=js&"
export * from "./reviewOpinion.vue?vue&type=script&lang=js&"
import style0 from "./reviewOpinion.vue?vue&type=style&index=0&id=4417bf3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4417bf3d",
  null
  
)

export default component.exports